import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import cx from 'classnames'
import UserRole from 'components/UserRole'
import UserOrganization from 'components/UserOrganization'
import TitledContent from 'components/TitledContent'
import Button from 'components/Button'
import Icon from 'components/Icon'
import { selectCurrentUser, submitUpdatePassword } from 'store/global'
import messages from './messages'
import styles from './UserProfile.scss'

function UserProfile({ intl }) {
  const dispatch = useDispatch()

  const currentUser = useSelector(selectCurrentUser)

  const [showModal, setShowModal] = useState(false)

  const onPasswordChangeSubmit = (currentPassword, newPassword) => {
    dispatch(submitUpdatePassword({ currentPassword, newPassword }))
    setShowModal(false)
  }

  const fields = [
    {
      key: 'fullName',
    },
    {
      key: 'organizationId',
      renderValue: () => <UserOrganization user={currentUser} />,
    },
    {
      key: 'roleId',
      renderValue: () => <UserRole user={currentUser} />,
    },
  ]

  return (
    <div className={styles.container}>
      <header className='page-header'>
        <h1 className={cx('page-title', 'h1')}>
          <FormattedMessage {...messages.header} values={{ email: currentUser.email }} tagName='span' />
        </h1>
      </header>
      <div className={styles.content}>
        <ul className={styles.fields}>
          {fields.map(({ key, renderValue = () => currentUser[key] }) => (
            <li key={key} className={styles.field}>
              <TitledContent
                title={intl.formatMessage(messages.fields[key])}
                titleClassName={styles.fieldTitle}
                contentClassName={styles.fieldContent}
              >
                {renderValue()}
              </TitledContent>
            </li>
          ))}
        </ul>
        <div className={styles.actions}>
          <Button buttonType='icon' onClick={() => setShowModal(true)}>
            <Icon name='edit' size='regular'>
              <FormattedMessage {...messages.actions.changePassword} />
            </Icon>
          </Button>
        </div>
      </div>
    </div>
  )
}

UserProfile.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(UserProfile)
